import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../apiConfig";
import "../Styles/userDashboard.css";
import Header from "../Components/Common/Header";
import Toast from "../Components/Common/Toast";
import { Home } from "lucide-react";

const UserDashboard = () => {
  const [location, setLocation] = useState(null);
  const [status, setStatus] = useState("Loading...");
  const [notification, setNotification] = useState({ type: '', message: '' });
  const navigate = useNavigate();

  useEffect(() => {
    const role = localStorage.getItem("userRole");
    if (role !== "user") {
      showNotification('error', "Access denied: Only users can access this page.");
      navigate("/");
    }
    
    // Fetch the user's current attendance status
    const fetchAttendanceStatus = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/attendance/status`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("idToken")}`,
          },
        });
          if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          window.location.href = '/';
          return;
        }
        
        const data = await response.json();
        if (data.success) {
          setStatus(data.status);
          localStorage.setItem("status", data.status); 
        } else {
          setStatus(localStorage.getItem("status") || "Not Checked In");
        }
      } catch (err) {
        console.error("Error fetching attendance status:", err);
        setStatus(localStorage.getItem("status") || "Not Checked In");
      }
    };
    
    fetchAttendanceStatus();
  }, [navigate]);

  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => setNotification({ type: '', message: '' }), 5000);
  };

  // const getLocation = () => {
  //   if (!navigator.geolocation) {
  //     showNotification('error', "Geolocation not supported");
  //     return;
  //   }
  //   navigator.geolocation.getCurrentPosition(
  //     (pos) => {
  //       const coords = {
  //         lat: pos.coords.latitude,
  //         lng: pos.coords.longitude,
  //       };
  //       setLocation(coords);
  //     },
  //     () => showNotification('error', "Unable to retrieve location")
  //   );
  // };

  // Refactored: handle check-in/out with location fetch in one click
  const handleCheckInOut = async (type) => {
    // Check if user is already checked in
    if (type === "Check In" && status === "Checked In") {
      showNotification('error', "You are already checked in. Please check out first.");
      return;
    }

    // Check if user is already checked out
    if (type === "Check Out" && status === "Checked Out") {
      showNotification('error', "You are already checked out. Please check in first.");
      return;
    }

    // Helper to perform check-in/out
    const doCheckInOut = async (coords) => {
      const endpoint = type === "Check In" ? "/attendance/check-in" : "/attendance/check-out";
      try {
        const response = await fetch(`${API_BASE_URL}${endpoint}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("idToken")}`,
          },
          body: JSON.stringify({
            latitude: coords.lat,
            longitude: coords.lng,
          }),
        });
        const data = await response.json();
        if (data.success) {
          const newStatus = type === "Check In" ? "Checked In" : "Checked Out";
          setStatus(newStatus);
          localStorage.setItem("status", newStatus);
          showNotification('success', data.message || `${type} successful!`);
        } else {
          showNotification('error', data.message || "Failed to process request.");
        }
      } catch (err) {
        console.error("Error during check-in/out:", err);
        showNotification('error', "An error occurred. Please try again.");
      }
    };

    if (!location) {
      if (!navigator.geolocation) {
        showNotification('error', "Geolocation not supported");
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const coords = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };
          setLocation(coords);
          doCheckInOut(coords); // Immediately proceed after location is fetched
        },
        () => showNotification('error', "Unable to retrieve location")
      );
      return;
    }
    // If location is already available
    doCheckInOut(location);
  };

  return (
    <>
      <div className="map-background">
      <Toast 
            type={notification.type} 
            message={notification.message} 
            onClose={() => setNotification({ type: '', message: '' })} 
          />
          
        <div className="user-dashboard">
         
          <Header 
            title="User Dashboard" 
            description="Welcome to your personal workspace" 
            icon={<Home size={28} color="#f3f4f6" />} 
          />

          {/* Status Card */}
          <div className="status-card">
            <h2>Status</h2>
            <p>{status}</p>
          </div>

          {/* Check In/Out Buttons */}
          <div className="check-buttons-grid">
            <div 
              className={`check-card ${status === "Checked In" ? "disabled" : ""}`} 
              onClick={() => handleCheckInOut("Check In")}
            >
              <h3>Check In</h3>
            </div>
            <div 
              className={`check-card ${status === "Checked Out" || status === "Not Checked In" ? "disabled" : ""}`} 
              onClick={() => handleCheckInOut("Check Out")}
            >
              <h3>Check Out</h3>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserDashboard;
